export default __webpack_public_path__ + "static/media/bysEmp.976921eb.svg";